// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// You must register a React component here before calling
// render_react_component in PHP
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

// ESNext imports
import React from 'react';
import AdvancedSearch from 'ui/advanced-search';
import BillingSettings from 'common/components/billing-settings';
import Button from 'common/components/button';
import IntegrationsSettings from 'common/components/integrations-settings/integrations-settings';
import Notification from 'common/components/notifications';
import SettingsNavigationTabs from 'common/components/settings-navigation-tabs/settings-navigation-tabs';
import Tooltip from 'common/components/tooltip';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import DropboxBilling from 'common/components/billing-settings/dropbox-billing';
import HelloReactApplication from 'hello-react/components/hello-react-application';
import APISettings from 'hellospa/components/api-settings';
import APIReferenceDoc from 'hellospa/components/api-reference-doc';
import SkipToContentLink from 'hellospa/components/skip-to-content-link';
import FoundationalButton from 'hellospa/foundation/control/button';
import { Title } from '@dropbox/dig-components/typography';
import { constructStore } from 'hellospa/redux/store';
import { buildWebAppClient } from 'hello-react/web-app-client/build-web-app-client';
import Error404Page from 'common/components/error-404-page/error-404-page';
import DownloadPage from '../../ui/download-page';
import { WhiteLabelingLandingPage } from '../../landing-pages/components/seo/white-labeling-landing-page';
import ApiMenu from './api-docs/api-menu';
import EmbeddedTestingTool from './api-docs/embedded-testing-tool';
import EmbeddedTestingToolV1 from './api-docs/embedded-testing-tool-v1';
import ImageModalTrigger from './api-docs/image-modal-trigger';
import AppFooter from './app/footer';
import AppTopBar from './app/header';
import AppLeftMenu from './app/sidebar';
import HSTeamPage from './app/content/team';
import FaxLineConfigList from './app/content/team/team-fax-lines';
import ConfirmRequiredPage from './auth/confirm-required-page';
import CreateAccount from './auth/create-account';
import CreateAccountTrigger from './auth/create-account-trigger';
import LogInForm from './auth/login-form';
import LogInVerificationForm from './auth/login-verification-form';
import OauthRequest from './auth/oauth/oauth-request';
import VerifyEmail from './auth/verify-email';
import CollectInfo from './home/collect-info';
import EsignDisclosurePreview from './home/esign-disclosure-preview';
import TopBarMenu from './home/top-bar-menu';
import PurgeDocumentSettings from './my-settings/purge-document-settings';
import PricingArea from './pricing';
import EnterpriseAgreement from './pricing/enterprise-agreement';
import TabbedArea from './tabbed-area';

const ImportContactsButton = React.lazy(async () => ({
  default: await (
    await import('hellospa/components/contact-input/import-contacts/button')
  ).ImportContactsButton,
}));

let sharedStore;
let sharedAppActions;
/**
 * WARNING: This is a hack to allow components in this file to have access to
 * Redux. It should NOT be used anywhere else.
 *
 * I don't have a good way to get the splits from prepareSPA, so this just
 * assumes splits are all off. That should be good enough for these very small
 * components.
 */
function WrapPHPComponent(Component, displayName) {
  function ComponentWrapper({ csrfToken, ...props }) {
    const { store, appActions } = React.useMemo(() => {
      sharedAppActions ??= buildWebAppClient('');
      sharedStore ??= constructStore(() => ({
        appActions: sharedAppActions,
        // Feature flags are provided in appliaction.js
        featureFlags: {},
      }));

      return {
        store: sharedStore,
        appActions: sharedAppActions,
      };
    }, []);

    return (
      <HelloReactApplication
        store={store}
        appActions={appActions}
        csrfToken={csrfToken}
        featureFlags={{}}
        csrfTokenAttachmentDelete=""
        preloadedTsmGroupKey=""
      >
        <Component {...props} />
      </HelloReactApplication>
    );
  }
  ComponentWrapper.displayName = `PHPApp(${displayName})`;

  return ComponentWrapper;
}

const WithRouting = (Component, displayName) => {
  const history = createBrowserHistory({});
  function ComponentWrapper(props) {
    return (
      <Router history={history}>
        <Component {...props} />
      </Router>
    );
  }
  ComponentWrapper.displayName = `WithRouting(${displayName})`;
  return ComponentWrapper;
};

/** Please DO NOT add any new components here. Use `prepareSPA` in PHP. */
const components = {
  APIReferenceDoc,
  APISettings,
  AdvancedSearch,
  ApiMenu,
  AppFooter,
  AppLeftMenu: WithRouting(AppLeftMenu),
  AppTopBar,
  BillingSettings,
  Button,
  CollectInfo,
  ConfirmRequiredPage,
  CreateAccount,
  CreateAccountTrigger,
  DownloadPage,
  DropboxBilling,
  EmbeddedTestingTool,
  EmbeddedTestingToolV1,
  EnterpriseAgreement,
  EsignDisclosurePreview,
  FaxLineConfigList,
  FoundationalButton,
  HSTeamPage,
  ImageModalTrigger,
  ImportContactsButton: WrapPHPComponent(
    ImportContactsButton,
    'ImportContactsButton',
  ),
  IntegrationsSettings,
  SettingsNavigationTabs,
  Error404Page,
  LogInForm,
  LogInVerificationForm,
  Notification,
  OauthRequest,
  PricingArea,
  PurgeDocumentSettings,
  SkipToContentLink,
  TabbedArea,
  Title,
  Tooltip,
  TopBarMenu,
  VerifyEmail,
  WhiteLabelingLandingPage,
};

export default components;
